// railDrag — whose press the navigator's ticker takes.
//
// The ticker (the title strip) turns a press that travels into a section change.
// The description under it wears the same gesture, so a finger can flick either
// band. Two presses are never the ticker's. One that lands in something being
// typed in, or the ✓ ✕ beside it: a drag there is selecting text, and it used to
// freeze mid-select, slide the title, and switch the section under the draft.
// And a MOUSE press on the description at all: a mouse drag across words is a
// selection, so the strip answers the mouse and the words do not. A finger or a
// pen on the description still flicks.
//
// Pure, so a test can hand in a plain object for the target.

export const RAIL_OWN_PRESS = 'textarea, input, select, [contenteditable]:not([contenteditable="false"]), .os-edit-actions';

/** the least of an Element the guard reads */
export interface PressLike {
  closest?: (selector: string) => unknown;
}

export function mayStartRailDrag(target: PressLike | null | undefined, pointerType: string, onSummary: boolean): boolean {
  if (onSummary && pointerType === "mouse") return false;
  if (target && typeof target.closest === "function" && target.closest(RAIL_OWN_PRESS)) return false;
  return true;
}
